/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FacilityResponseOfMasteredLocations } from '../models/facility-response-of-mastered-locations';
import { FacilitySearchRequest } from '../models/facility-search-request';
import { FileStreamResult } from '../models/file-stream-result';
import { ProviderResponseOfMasteredLocations } from '../models/provider-response-of-mastered-locations';
import { ProviderSearchRequest } from '../models/provider-search-request';
import { Stream } from '../models/stream';

@Injectable({
  providedIn: 'root',
})
export class PrintService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getSingleProviderPrintPdf
   */
  static readonly GetSingleProviderPrintPdfPath = '/print/carefindr/print-single-provider';

  /**
   * Print Search Results.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSingleProviderPrintPdf()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  getSingleProviderPrintPdf$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Practitioner data to be printed
     */
    body: ProviderResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileStreamResult>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.GetSingleProviderPrintPdfPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Print Search Results.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSingleProviderPrintPdf$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  getSingleProviderPrintPdf(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Practitioner data to be printed
     */
    body: ProviderResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<FileStreamResult> {

    return this.getSingleProviderPrintPdf$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileStreamResult>) => r.body as FileStreamResult)
    );
  }

  /**
   * Path part for operation getSingleFacilityPrintPdf
   */
  static readonly GetSingleFacilityPrintPdfPath = '/print/carefindr/print-single-facility';

  /**
   * Print Search Results.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSingleFacilityPrintPdf()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  getSingleFacilityPrintPdf$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Facility data to be printed
     */
    body: FacilityResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Stream>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.GetSingleFacilityPrintPdfPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Stream>;
      })
    );
  }

  /**
   * Print Search Results.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSingleFacilityPrintPdf$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  getSingleFacilityPrintPdf(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Facility data to be printed
     */
    body: FacilityResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<Stream> {

    return this.getSingleFacilityPrintPdf$Response(params,context).pipe(
      map((r: StrictHttpResponse<Stream>) => r.body as Stream)
    );
  }

  /**
   * Path part for operation providerPrintSingleCarefindrV3
   */
  static readonly ProviderPrintSingleCarefindrV3Path = '/provider/print/{uid}';

  /**
   * Print Search Results for a single provider. Use with CarefindrV3.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `providerPrintSingleCarefindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  providerPrintSingleCarefindrV3$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Practitioner data to be printed
     */
    body: ProviderResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileStreamResult>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.ProviderPrintSingleCarefindrV3Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Print Search Results for a single provider. Use with CarefindrV3.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `providerPrintSingleCarefindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  providerPrintSingleCarefindrV3(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Practitioner data to be printed
     */
    body: ProviderResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<FileStreamResult> {

    return this.providerPrintSingleCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileStreamResult>) => r.body as FileStreamResult)
    );
  }

  /**
   * Path part for operation facilityPrintSingleCarefindrV3
   */
  static readonly FacilityPrintSingleCarefindrV3Path = '/facility/print/{uid}';

  /**
   * Print Search Results for a single facility. Use with CarefindrV3.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityPrintSingleCarefindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  facilityPrintSingleCarefindrV3$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Facility data to be printed
     */
    body: FacilityResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Stream>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.FacilityPrintSingleCarefindrV3Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Stream>;
      })
    );
  }

  /**
   * Print Search Results for a single facility. Use with CarefindrV3.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityPrintSingleCarefindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  facilityPrintSingleCarefindrV3(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Facility data to be printed
     */
    body: FacilityResponseOfMasteredLocations
  },
  context?: HttpContext

): Observable<Stream> {

    return this.facilityPrintSingleCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<Stream>) => r.body as Stream)
    );
  }

  /**
   * Path part for operation multiTenantFullDirectoryPrintRetrieve
   */
  static readonly MultiTenantFullDirectoryPrintRetrievePath = '/v3/full-directory/print';

  /**
   * Full Directory Print Retrieve (for planState).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantFullDirectoryPrintRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantFullDirectoryPrintRetrieve$Response(params: {
    planState: string;

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.MultiTenantFullDirectoryPrintRetrievePath, 'get');
    if (params) {
      rb.query('planState', params.planState, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Full Directory Print Retrieve (for planState).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantFullDirectoryPrintRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantFullDirectoryPrintRetrieve(params: {
    planState: string;

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.multiTenantFullDirectoryPrintRetrieve$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation multiTenantFullDirectoryPrintKickOff
   */
  static readonly MultiTenantFullDirectoryPrintKickOffPath = '/v3/full-directory/print';

  /**
   * Full Directory Print Kickoff (for planState).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantFullDirectoryPrintKickOff()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantFullDirectoryPrintKickOff$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for providers (same as search API)
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.MultiTenantFullDirectoryPrintKickOffPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Full Directory Print Kickoff (for planState).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantFullDirectoryPrintKickOff$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantFullDirectoryPrintKickOff(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for providers (same as search API)
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<string> {

    return this.multiTenantFullDirectoryPrintKickOff$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation multiTenantProviderPrintAllV2CareFindr
   */
  static readonly MultiTenantProviderPrintAllV2CareFindrPath = '/v3/provider/printall-carefindr';

  /**
   * Multi-tenant print all providers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantProviderPrintAllV2CareFindr()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantProviderPrintAllV2CareFindr$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for providers (same as search API)
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileStreamResult>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.MultiTenantProviderPrintAllV2CareFindrPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Multi-tenant print all providers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantProviderPrintAllV2CareFindr$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantProviderPrintAllV2CareFindr(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for providers (same as search API)
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<FileStreamResult> {

    return this.multiTenantProviderPrintAllV2CareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileStreamResult>) => r.body as FileStreamResult)
    );
  }

  /**
   * Path part for operation multiTenantFacilityPrintAllV2CareFindr
   */
  static readonly MultiTenantFacilityPrintAllV2CareFindrPath = '/v3/facility/printall-carefindr';

  /**
   * Multi-tenant print all facilities.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantFacilityPrintAllV2CareFindr()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantFacilityPrintAllV2CareFindr$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for facilities (same as search API)
     */
    body: FacilitySearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileStreamResult>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.MultiTenantFacilityPrintAllV2CareFindrPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Multi-tenant print all facilities.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantFacilityPrintAllV2CareFindr$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantFacilityPrintAllV2CareFindr(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for facilities (same as search API)
     */
    body: FacilitySearchRequest
  },
  context?: HttpContext

): Observable<FileStreamResult> {

    return this.multiTenantFacilityPrintAllV2CareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileStreamResult>) => r.body as FileStreamResult)
    );
  }

  /**
   * Path part for operation providerPrintAllCarefindrV3
   */
  static readonly ProviderPrintAllCarefindrV3Path = '/provider/print';

  /**
   * Prints all providers for this search. Use in CarefindrV3.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `providerPrintAllCarefindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  providerPrintAllCarefindrV3$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for providers (same as search API)
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileStreamResult>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.ProviderPrintAllCarefindrV3Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Prints all providers for this search. Use in CarefindrV3.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `providerPrintAllCarefindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  providerPrintAllCarefindrV3(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for providers (same as search API)
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<FileStreamResult> {

    return this.providerPrintAllCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileStreamResult>) => r.body as FileStreamResult)
    );
  }

  /**
   * Path part for operation facilityPrintAllCarefindrV3
   */
  static readonly FacilityPrintAllCarefindrV3Path = '/facility/print';

  /**
   * Prints all facilities for this search. Use in CarefindrV3.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityPrintAllCarefindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  facilityPrintAllCarefindrV3$Response(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for facilities (same as search API)
     */
    body: FacilitySearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileStreamResult>> {

    const rb = new RequestBuilder(this.rootUrl, PrintService.FacilityPrintAllCarefindrV3Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Prints all facilities for this search. Use in CarefindrV3.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityPrintAllCarefindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  facilityPrintAllCarefindrV3(params: {

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Search request for facilities (same as search API)
     */
    body: FacilitySearchRequest
  },
  context?: HttpContext

): Observable<FileStreamResult> {

    return this.facilityPrintAllCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileStreamResult>) => r.body as FileStreamResult)
    );
  }

}
